// extracted by mini-css-extract-plugin
export var section = "solutions-module--section--2DxEn";
export var inner = "solutions-module--inner--2MS1y";
export var title = "solutions-module--title--1khtr";
export var list = "solutions-module--list--ETKOi";
export var jsAnimInit = "solutions-module--jsAnimInit--1nZB1";